"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Tabs = require("../../Tabs.styled");
var _TabsProvider = require("../../TabsProvider");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3;
var _excluded = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TabsContents = function TabsContents(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = (0, _TabsProvider.useTabsContext)();
  if (!context) {
    throw new Error("Tabs isn't wrapped by TabsProvider");
  }
  var activeTabIndex = context.activeTabIndex,
    activeTab = context.activeTab,
    oldIndex = context.oldIndex;
  var activeIndex = (0, _react.useMemo)(function () {
    var _children = _react["default"].Children.toArray(children);
    var selected = _children.findIndex(function (_) {
      return _.props.value === activeTab;
    });
    return selected !== null && selected !== void 0 ? selected : activeTabIndex;
  }, [activeTabIndex, activeTab, children]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children && /*#__PURE__*/_react["default"].createElement(TabContentsSwiperWrapper, props, /*#__PURE__*/_react["default"].createElement(TabContentsSwiper, {
    className: "tabs-contents-swiper",
    activeIndex: activeIndex
  }, _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(TabContentWrapper, {
      className: "tabs-contents-inner-wrapper",
      current: activeIndex,
      oldIndex: oldIndex !== null && oldIndex !== void 0 ? oldIndex : 0,
      index: index
    }, child);
  }))));
};
var _default = TabsContents;
exports["default"] = _default;
var TabContentsSwiperWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t/* display: flex; */\n\toverflow: hidden;\n\tmin-width: 100%;\n\t", ";\n"])), _styledSystem.layout);
var TabContentsSwiper = _styledComponents["default"].div.attrs(function (props) {
  return {
    dir: document.documentElement.dir
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tmin-width: 100%;\n\tflex: 1;\n"])));
var TabContentWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tflex: 1;\n\tflex-grow: 1;\n\toverflow: hidden;\n\tmin-width: 100%;\n\tdisplay: ", ";\n\t", ";\n\t", ";\n"])), function (_ref2) {
  var index = _ref2.index,
    current = _ref2.current;
  return index === current ? 'block' : 'none';
}, function (_ref3) {
  var index = _ref3.index,
    oldIndex = _ref3.oldIndex;
  return index > oldIndex && _Tabs.SlideLeftAnimation;
}, function (_ref4) {
  var index = _ref4.index,
    oldIndex = _ref4.oldIndex;
  return index < oldIndex && _Tabs.SlideRightAnimation;
});